<template>
  <div class="card card-body card-commercials">
    <div class="row" v-if="commercialResearches.length > 0">
      <div class="col-12 d-flex justify-content-end mb-3">
        <v-button
          icon="plus"
          :text="`phrase.register_${commercialType}_commercial`"
          :route-to="{name: 'organisation-register-research-start', query: {commercialType}}"
        />
      </div>
      <div
        class="col-lg-4"
        v-for="research in commercialResearches"
        :key="research.research_uuid"
      >
        <v-organisation-commercial-research-card
          :research="research"
        />
      </div>
    </div>
    <div
      v-else
      class="is-empty d-flex justify-content-center align-items-center flex-column text-muted"
    >
      <div class="mb-3 d-flex justify-content-center align-items-center flex-column">
        <i class="fa fa-folder-open icon-large mb-2"></i>
        {{ emptyText }}
      </div>

      <v-button
        icon="plus"
        text="phrase.register_now"
        :route-to="{name: 'organisation-register-research-start', query: {commercialType}}"
      />
    </div>
  </div>
</template>

<script>
import OrganisationCommercialResearchCard from '@/organisation/components/OrganisationCommercialResearchCard.vue';
import Button from '@/common/components/Button.vue';

export default {
  name: 'OrganisationCommercialResearchCardList',
  components: {
    'v-button': Button,
    'v-organisation-commercial-research-card': OrganisationCommercialResearchCard,
  },
  props: {
    commercialType: {
      required: true,
      type: String,
    },
    organisationSlug: {
      required: true,
      type: String,
    },
    researches: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    commercialResearches() {
      return this.researches
        .filter((research) => (
          !!research.commercial && research.commercial.commercial_type === this.commercialType
        ));
    },
    emptyText() {
      return this.$t(
        'sentence.no_commercials',
        {
          commercialType: this.$tc(`word.${this.commercialType}_commercial`, 1)
            .toLowerCase(),
        },
      );
    },
  },
};
</script>

<style scoped>
.is-empty {
  width: 100%;
  height: 265px;
}
</style>
